<template>
  <toolbox-window title="Add Lights" icon="highlight" class="lights-menu">
    <v-flex
      xs12
      sm6
      md3
      pa-2
      d-flex
    >
      <light-preview name="Point light" :image="image" @click.native="addLight">
        <p>A that emits from a single point. Similar to a bare lightbulb.</p>
      </light-preview>
    </v-flex>
  </toolbox-window>
</template>

<script>
import ToolboxWindow from '@/components/SceneToolbox/ToolboxWindow.vue'
import LightPreview from './LightPreview.vue'

export default {
  name: 'LightsMenu',
  components: {
    ToolboxWindow,
    LightPreview
  },
  data () {
    return {
      image: 'http://blog.disignstudio.com/wp-content/uploads/2017/11/blog_MaterialsandLight_LambertMaterialPointLight-825x510.jpg'
    }
  },
  methods: {
    addLight () {
      const light = {
        name: 'Point Light',
        type: 'PointLight',
        colour: '#fff',
        intensity: 1,
        scale: {
          x: 1,
          y: 1,
          z: 1
        },
        position: {
          x: 0,
          y: 0,
          z: 0
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0
        }
      }

      this.$store.commit('three/addNode', { node: light })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
